/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CommentCreatedUser } from './commentCreatedUser';


/**
 * Data payload for \'comment.created\' notifications.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface CommentCreatedData { 
    taskId: number;
    commentId: number;
    commentText: string;
    createdBy: CommentCreatedUser;
}
export const CommentCreatedData_taskId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommentCreatedData_commentId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommentCreatedData_commentText_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommentCreatedData_createdBy_Validators: ValidatorFn[] =
    [  Validators.required, ];


